<template>
  <v-app>
    <div id="app">
      <router-view></router-view>
    </div>
  </v-app>
</template>

<script>

export default {
  name: "App"
};
</script>

<style>
  #app {
    font-family: "Sarabun", sans-serif;
    color: #161616;
  }
</style>
